import {createContext, PropsWithChildren, useEffect, useState} from "react"
import {RefineThemes} from "@refinedev/antd"
import {ConfigProvider, theme} from "antd"

import dayjs from "dayjs"
import {i18nProvider, antdLocales, dayjsLocales} from "../../resources/i18nProvider"

type ColorModeContextType = {
    mode: boolean
    setMode: () => void
}
const {darkAlgorithm, defaultAlgorithm} = theme

export const ColorModeContext = createContext<ColorModeContextType>({} as ColorModeContextType)

export const ColorModeContextProvider: React.FC<PropsWithChildren> = ({children}) => {
    const storage = localStorage.getItem('darkMode') === 'true'
    const preference = !!window?.matchMedia('(prefers-color-scheme: dark)').matches
    const [mode, setMode] = useState(storage || preference)
    useEffect(() => window.localStorage.setItem('darkMode', '' + mode), [mode])

    const {getLocale} = i18nProvider();
    const [antdLocale, setAntdLocale] = useState(antdLocales[getLocale()]);
    useEffect(() => {
        setAntdLocale(antdLocales[getLocale()]);
        dayjs.locale(dayjsLocales[getLocale()]);
    }, [getLocale()]);

    return (
        <ColorModeContext.Provider value={{setMode: () => setMode(!mode), mode}}>
            <ConfigProvider locale={antdLocale}
                            theme={{...RefineThemes.Blue, algorithm: mode ? darkAlgorithm : defaultAlgorithm}}>
                {children}
            </ConfigProvider>
        </ColorModeContext.Provider>
    )
}
